const PNF = require('google-libphonenumber').PhoneNumberFormat;
const PNT = require('google-libphonenumber').PhoneNumberType;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

class PhoneNumberService {
  static getExampleNumber (countryCode, national, numberType = PNT.MOBILE) {

    try {
      const numberObj = phoneUtil.getExampleNumberForType(countryCode, numberType);
      var format = national ? PNF.NATIONAL : PNF.INTERNATIONAL;

      return phoneUtil.format(numberObj, format);
    } catch (e) {
      return '';
    }
  }
}

export default PhoneNumberService;
